import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';

import wsMiddleware from '../features/spectrasWebSocketServer/wsMiddleware';

import appReducer from './appSlice';
import analyzerReducer from '../features/analyzers/analyzerSlice';
import snapshotsReducer from '../features/snapshots/snapshotsSlice';
import markersReducer from '../features/markers/markersSlice';
import spectrasWebSocketServerReducer from '../features/spectrasWebSocketServer/spectrasWebSocketServerSlice';
import wallsReducer from '../features/walls/wallsSlice';
import windowsReducer from '../features/windows/windowsSlice';
import authReducer from '../features/auth/authSlice';
import userReducer from '../features/userManagement/userSlice';

const combinedReducer = combineReducers({
  app: appReducer,
  spectrasWebSocketServer: spectrasWebSocketServerReducer,
  auth: authReducer,
  users: userReducer,
  analyzers: analyzerReducer,
  snapshots: snapshotsReducer,
  markers: markersReducer,
  walls: wallsReducer,
  windows: windowsReducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === 'auth/logoutSuccess') {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(wsMiddleware),
});

export type StoreType = typeof store;
export type AppDispatch = typeof store.dispatch;

export default store;
